import React from "react";
import PropTypes from "prop-types";
import Stacked from "./Stacked";
import Slider from "./Slider";

const ProductInformation = (props) => {
  if (props.primary.layout === "slider") {
    return (
      <Slider
        id={props.id}
        isReversed={props.primary.reversed === "true"}
        cta={props.primary.cta}
        link={props.primary.href}
        items={props.items}
        handleClick={props.handleClick(props.primary.href, props.countryModel)}
      />
    );
  }
  return (
    <Stacked
      id={props.id}
      productId={props.productId}
      cta={props.primary.cta}
      link={props.primary.href}
      items={props.items}
      handleClick={props.handleClick(props.primary.href, props.countryModel)}
    />
  );
};

ProductInformation.propTypes = {
  id: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  primary: PropTypes.shape({
    cta: PropTypes.string,
    href: PropTypes.string,
    layout: PropTypes.string.isRequired,
    reversed: PropTypes.string,
  }),
  items: PropTypes.array.isRequired,
  countryModel: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default ProductInformation;
